// extracted by mini-css-extract-plugin
export default {"wrapper":"Maintenance_wrapper__9xNEp"};